const AUDIT_PATH_PREFIX = '/audit/';

/**
 * True for the external auditor's surface.
 *
 * Deliberately keyed on the PATH, never on "the signed-in user has no
 * organisation" (OI-14). An org-less predicate would look equivalent and would
 * quietly strand every genuinely unprovisioned customer: `PrivateRoute` sends
 * `no-org` to /init on purpose, and that is the correct behaviour for a real
 * customer mid-signup. Only this path is exempt.
 *
 * See docs/features/verifier-access/phase-2-auditor-surface.md.
 */
export function isAuditPath(pathname) {
  if (typeof pathname !== 'string') return false;
  return pathname.startsWith(AUDIT_PATH_PREFIX);
}

export default isAuditPath;
